var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AlertsComponent } from './src/alerts.component';
import { AlertsService } from './src/alerts.service';
import { AlertComponent } from './src/alert.component';
export * from './src/alert.component';
export * from './src/alerts.component';
export * from './src/alerts.service';
var JasperoAlertsModule = (function () {
    function JasperoAlertsModule() {
    }
    return JasperoAlertsModule;
}());
JasperoAlertsModule = __decorate([
    NgModule({
        imports: [CommonModule],
        declarations: [
            AlertsComponent,
            AlertComponent
        ],
        providers: [AlertsService],
        exports: [AlertsComponent]
    })
], JasperoAlertsModule);
export { JasperoAlertsModule };
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@jaspero/ng2-alerts/dist/index.js
// module id = 170
// module chunks = 3